import React from 'react'
import StatusBadge from 'components/atoms/status-badge'
import { VOUCHER_GENERATE_FLAG } from 'domains/customer-refund-voucher/constants'
import PropTypes from 'prop-types'

const propTypes = {
  status: PropTypes.string
}

const defaultProps = {
  status: 'pending'
}

const CustomerRefundVoucherGenerateStatusBadge = ({ status }) => {

  const colorMap = {
    [VOUCHER_GENERATE_FLAG.PENDING]   : 'danger',
    [VOUCHER_GENERATE_FLAG.COMPLETED] : 'success'
  }

  const color = colorMap[status]

  return <StatusBadge color={ color } label={ status } />
}

CustomerRefundVoucherGenerateStatusBadge.propTypes    = propTypes
CustomerRefundVoucherGenerateStatusBadge.defaultProps = defaultProps

export default CustomerRefundVoucherGenerateStatusBadge
